var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSignUpIconGradientUiSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 60 60"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sign-up-icon-gradient-ui-success_svg__a",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ee4823"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f9a13a"
})))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 617",
  cx: 30,
  cy: 30,
  r: 30,
  fill: "url(#sign-up-icon-gradient-ui-success_svg__a)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.015 36.017l17-17a2.251 2.251 0 011.648-.694 2.251 2.251 0 011.648.694 2.251 2.251 0 01.694 1.648 2.251 2.251 0 01-.694 1.648L26.648 40.976a2.23 2.23 0 01-1.628.694 2.23 2.23 0 01-1.628-.694l-8.71-8.71a2.185 2.185 0 01-.675-1.648 2.322 2.322 0 01.714-1.648 2.251 2.251 0 011.648-.694 2.251 2.251 0 011.648.694z",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/sign-up-icon-gradient-ui-success.303ad341939280f4215aacce8998bfa7.svg";
export { SvgSignUpIconGradientUiSuccess as ReactComponent };